import { useEffect } from "react";

import { useLocation, useNavigate } from "react-router-dom";

const TouchpointPageRedirect = () => {
  const { pathname, search, state } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Replace so the bare /creative/:id URL is not left in history; otherwise the browser
    // "back" action returns to a route that immediately redirects to preview again and the
    // user cannot leave the touchpoint (e.g. from /approved).
    navigate(`${pathname}/preview${search}`, { replace: true, state });
    // eslint-disable-next-line
  }, []);

  return null;
};

export default TouchpointPageRedirect;
